<template>
<div>
     <!-- 订单详情弹窗 -->
      <el-dialog
        :title="this.titleDetail"  @close="closeDialog"
        :visible.sync="detailsMark"
        :close-on-click-modal="false"
        width="80%"
        center
      >
        <!-- ==================================================================================订单 -->
        <div v-loading="loading">
          <el-form
            :inline="true"
            ref="goodform"
            enctype="multipart/form-data"
            :model="goodform"
            class="demo-form-inline"
            label-width="110px"
            size="mini"
          >
            <div class="addressBoxTitle" v-if="this.num == '0'">
              <div>订单号 ：{{ goodform.orderNo }}</div>
            </div>
            <div class="addressBoxTitle" v-else-if="this.num == '1'">
              <div  style="margin-right:100px">运单号 ：{{ goodform.wayNo }}</div>
              <div>所属订单 ：{{ goodform.orderNo }}</div>
            </div>
            <hr />
            <div class="addressBox">
              <h4 class="title">
                <span>
                  <i class="fa fa-cubes iconFont" aria-hidden="true"></i
                  >货物信息
                </span>
              </h4>
              <div>
                <el-form-item
                  label="货物类型 :"
                  class="jiage"
                  prop="productType"
                >
                  <div style="width:138px">{{ goodform.productTypeName }} </div>
                </el-form-item>
                <el-form-item label="调度量 :" class="jiage" prop="weight">
                    <span>{{ goodform.weight }}</span>
                    <span class>{{ goodform.unitMeasurement }}</span>
                </el-form-item>
                <el-form-item label="装车量 :" class="jiage" prop="num">
                  <span>{{ goodform.loadingWeight }}</span>
                  <span class>{{ goodform.unitMeasurement }}</span>
                </el-form-item>
                <el-form-item label="卸车量 :" class="jiage" prop="num">
                  <span>{{ goodform.unloadingWeight }}</span>
                  <span class>{{ goodform.unitMeasurement }}</span>
                </el-form-item>
              </div>
              <div v-if="this.num == '0'">
                <el-form-item
                  label="发单时间 :"
                  class="jiage"
                  prop="transportStartOperateDate"
                >
                  <span>{{
                    goodform.transportStartOperateDate | dateFormat
                  }}</span>
                </el-form-item>
                <el-form-item
                  label="送达时间 :"
                  class="jiage"
                  prop="transportEndOperateDate"
                >
                  <span>{{
                    goodform.transportEndOperateDate | dateFormat
                  }}</span>
                  <span class></span>
                </el-form-item>
              </div>
              <div v-else-if="this.num == '1'">
                <el-form-item
                  label="接单时间 :"
                  class="jiage"
                  prop="receivingTime"
                >
                  <span>{{ goodform.receivingTime | dateFormat }}</span>
                </el-form-item>
                <el-form-item
                  label="送达时间 :"
                  class="jiage"
                  prop="arrivalTime"
                >
                  <span>{{ goodform.arrivalTime | dateFormat }}</span>
                  <span class></span>
                </el-form-item>
              </div>
            </div>
            <hr />
            <div class="addressBox">
              <h4 class="title">
                <span>
                  <i class="fa fa-envelope iconFont" aria-hidden="true"></i
                  >货运信息
                </span>
              </h4>
              <div class="box1">
                <div class="item" style="margin-bottom:20px">
                  <div class="box1T" v-if="this.num == '0'">
                    <i style="color: #fc9727" class="el-icon-location"></i>
                    发货地址 ：
                    <span style="color: #fc9727">{{
                      goodform.deliverCompany
                    }}</span>
                  </div>
                  <div class="box1T" v-else-if="this.num == '1'">
                    <i style="color: #fc9727" class="el-icon-location"></i>
                    发货地址 ：
                    <span style="color: #fc9727">{{
                      goodform.deliverCompany
                    }}</span>
                  </div>
                  <div class="box1B">
                    <span
                      >{{
                        goodform.deliverPerson
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span
                      >{{
                        goodform.deliverPhone
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span>{{ goodform.deliverAddress }}</span>
                  </div>
                </div>
                <div class="item">
                  <div class="box1T" v-if="this.num == '0'">
                    <i style="color: #1ea827" class="el-icon-location"></i>
                    收货地址 ：
                    <span style="color: #1ea827">{{
                      goodform.receivingCompany
                    }}</span>
                  </div>
                  <div class="box1T" v-else-if="this.num == '1'">
                    <i style="color: #1ea827" class="el-icon-location"></i>
                    收货地址 ：
                    <span style="color: #1ea827">{{
                      goodform.receivingCompany
                    }}</span>
                  </div>
                  <div class="box1B">
                    <span
                      >{{
                        goodform.receivingPerson
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span
                      >{{
                        goodform.receivingPhone
                      }}&nbsp;&nbsp;/&nbsp;&nbsp;</span
                    >
                    <span>{{ goodform.receivingAddress }}</span>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div
                    class="addressBox"
                    v-if="this.goodform.goodList"
                  >
                    <h4 class="title">
                      <span>
                        <i class="fa fa-bars iconFont" aria-hidden="true"></i
                        >货物详情
                      </span>
                    </h4>
                    <div>
                      <el-table
                        height="200px"
                        size="mini"
                        ref="tabref"
                        :data="this.goodform.goodList"
                        style="width: 100%"
                        class="elTab"
                        :header-cell-style="{
                          background: '#F5F5F5',
                          color: 'black',
                        }"
                      >
                        <el-table-column
                          type="index"
                          align="center"
                          label="序号"
                          width="60"
                        ></el-table-column>
                        <el-table-column
                          :show-overflow-tooltip="true"
                          prop="cargoBarcode"
                          label="捆包号"
                          align="center"
                          :formatter="emptyFn"
                        ></el-table-column>
                        <el-table-column
                          :show-overflow-tooltip="true"
                          prop="productName"
                          label="品名"
                          :formatter="emptyFn"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          :show-overflow-tooltip="true"
                          prop="brand"
                          label="牌号"
                          :formatter="emptyFn"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          :show-overflow-tooltip="true"
                          prop="specification"
                          label="规格"
                          :formatter="emptyFn"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          :show-overflow-tooltip="true"
                          prop="model"
                          label="材质"
                          :formatter="emptyFn"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          :show-overflow-tooltip="true"
                          prop="weight"
                          label="重量（吨）"
                          :formatter="emptyFn"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          :show-overflow-tooltip="true"
                          prop="position"
                          label="库位"
                          align="center"
                          :formatter="emptyFn"
                        ></el-table-column>
                      </el-table>
                    </div>
                    <hr />
                  </div>
            <div class="addressBox" v-if="this.num == '0'">
              <h4 class="title">
                <span>
                  <i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i
                  >运单信息
                </span>
              </h4>
              <div>
                <el-table
                  height="300px"
                  size="mini"
                  ref="tabref"
                  :data="this.goodform.sWayList"
                  style="width: 100%"
                  class="elTab"
                  border
                  :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
                >
                  <el-table-column
                    prop="wayNo"
                    label="运单号"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="dirverName"
                    label="司机姓名"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="vhcNo"
                    label="车牌号"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="weight"
                    label="调度量"
                    :formatter="emptyFn"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="loadingWeight"
                    label="装车量"
                    :formatter="emptyFn"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="unloadingWeight"
                    label="卸车量"
                    :formatter="emptyFn"
                    align="center"
                  ></el-table-column>
                   <el-table-column property="waybillMode" label="收款人" >
                    <template scope="scope">
                      <div>
                      <span v-if="scope.row.waybillMode==1">{{scope.row.dirverName}}</span>
                      <span v-if="scope.row.waybillMode==2">{{scope.row.captainName}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column property="waybillMode"  width="120" label="收款人类型" >
                    <template scope="scope">
                      {{[ "司机", "车队长"][scope.row.waybillMode-1]}}
                    </template>
                  </el-table-column>
                  <el-table-column label="凭证" align="center">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="mini"
                        @click="QualityClick(scope.row)"
                        >查看</el-button
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="货物详情" align="center">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="mini"
                        @click="QualityClick2(scope.row)"
                        >查看</el-button
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="receivingTime" width="110"
                    label="接单时间"
                    align="center"
                    :formatter="dateTimeFormat"
                  ></el-table-column>
                  <el-table-column
                    prop="outTime" width="110"
                    label="装车时间"
                    align="center"
                    :formatter="dateTimeFormat"
                  ></el-table-column>
                  <el-table-column
                    prop="arrivalTime" width="110"
                    label="到货时间"
                    align="center"
                    :formatter="dateTimeFormat"
                  ></el-table-column>
                  <el-table-column
                    prop="signingTime" width="110"
                    label="签收时间"
                    align="center"
                    :formatter="dateTimeFormat"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
            <div v-else-if="this.num == '1'">
                <div class="addressBoxImg addressBox" v-if="loadingImgs.length>0">
              <h4 class="title">
                <span>
                  <i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i
                  >装车凭证
                </span>
              </h4>
              <div>
                <ul class="ul">
                  <li v-for="(item,index) in srcList" :key="index">
                    <el-image
                      fit="cover"
                      style="width: 150px; height: 150px"
                      :src="item"
                      :preview-src-list="srcList"
                    >
                    </el-image>
                  </li>
                </ul>
                <div><span style="margin-right:46px;">上传人：{{loadingImgs[0].createUserName}}</span><span>上传时间：{{loadingImgs[0].createTime|dateFormat}} </span></div>
              </div>
            </div>
            <hr />
            <div class="addressBoxImg addressBox" v-if="unloadImgs.length>0">
              <h4 class="title">
                <span>
                  <i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i
                  >卸车凭证
                </span>
              </h4>
              <div >
                <ul class="ul">
                  <li v-for="(item,index) in srcList2" :key="index">
                    <el-image
                      fit="cover"
                      style="width: 150px; height: 150px"
                      :src="item"
                      :preview-src-list="srcList2"
                    >
                    </el-image>
                  </li>
                </ul>
                  <div><span style="margin-right:46px;">上传人：{{unloadImgs[0].createUserName}}</span><span>上传时间：{{unloadImgs[0].createTime|dateFormat}} </span></div>
              </div>
            </div>
            <hr />
            </div>

          </el-form>
        </div>

        <!-- ----------------------------------------------------------------------------------运单 -->
        <span slot="footer" class="dialog-footer">
           <el-button type="primary" @click="detailsMark = false">关闭</el-button>
        </span>
      </el-dialog>
     <!-- 查看凭证弹框 -->
    <lookVoucher
      :row-data="row"
      v-if="zujianFlag"
      @destroy="destroy"
    ></lookVoucher>
    <!-- 查看货物详情 -->
    <lookGoodsDetails
      :row-data-list="rows"
      v-if="zujianFlag2"
      @detailDestroy="detailDestroy"
    ></lookGoodsDetails>
</div>
</template>

<script>
import { getListWayByOrderNo, getbusinessNo } from '@/api/consignment'
import lookVoucher from '@/components/networkFreight/lookVoucher.vue'
import lookGoodsDetails from '@/components/lookGoodsDetails.vue'
import DonMessage from '@/utils/message'
import { emptyFn, dateTimeFormat } from '@/utils/util'
export default {
  name: 'orderDatil',
  components: {
    lookGoodsDetails,
    lookVoucher
  },
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      // 订单详情
      detailsMark: false,
      goodform: {},
      num: 0,
      titleDetail: '',
      zujianFlag: false, // 凭证
      zujianFlag2: false // 货物详情
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.detailsMark = true
    this.loading = true
    this.goodform = {}
    this.titleDetail = '订单详情'
    if (this.rowData.businessType == 2) {
      getbusinessNo({
        businessNo: this.rowData.businessNo
      }).then((res) => {
        this.loading = false
        this.num = 1
        this.goodform = res
        // 获取抢单计价方式：1：单价；2：按单
        if (this.goodform.valuationType == 1) {
          this.goodform.valuationType = '单价'
        } else if (this.goodform.valuationType == 2) {
          this.goodform.valuationType = '按单'
        } else {
          this.goodform.valuationType = ''
        }
        this.loadingImgs = res.loadingImgs
        this.unloadImgs = res.unloadImgs
        this.srcList = []
        this.srcList2 = []
        this.loadingImgs.forEach((item, index) => {
          this.srcList.push(item.fileUrlOSS)
        })
        this.unloadImgs.forEach((item, index) => {
          this.srcList2.push(item.fileUrlOSS)
        })
        // this.srcList.push(this.goodform.imageUrl, this.goodform.imageUrl2)
      }).catch((err) => {
        this.loading = false
        DonMessage.error(err.message)
      })
    } else {
      // 订单
      getListWayByOrderNo({
        orderNo: this.rowData.businessNo
      }).then((res) => {
        if (res != null) {
          this.loading = false
          this.num = 0
          this.goodform = res
          // 1.单价，2.包干
          if (this.goodform.pricingMethod == 1) {
            this.goodform.pricingMethod = '单价'
          } else {
            this.goodform.pricingMethod = '包干'
          }
          this.sun = '0'
          this.sun = (
            this.goodform.fatePrice + this.goodform.taxation
          ).toFixed(2)
        } else {
          this.loading = false
          DonMessage.error('查无此订单')
        }
      }).catch((err) => {
        this.loading = false
        DonMessage.error(err.message)
      })
    }
  },
  methods: {
    // 点击订单号进入单号页面
    seeClickNO (row) {

    },
    // 凭证
    QualityClick (row) {
      this.row = row
      this.zujianFlag = true
    },
    // 组件销毁
    destroy () {
      this.zujianFlag = false
    },
    // 货物详情
    QualityClick2 (row) {
      this.rows = row
      this.zujianFlag2 = true
    },
    // 组件销毁
    detailDestroy () {
      this.zujianFlag2 = false
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form--inline .diqu .el-form-item__content{
      flex-direction: row;
}
/deep/.el-image {
  margin: 10px;
}
.addressBoxTitle{
  display: flex;
}
.addressBoxImg {
  .ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 150px;
      height: 150px;
      border-radius: 20px;
      overflow: hidden;
      border: 1px dashed #ccc;
      margin-right: 30px;
      text-align: center;

      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .ul2 {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 150px;
      margin-right: 30px;

      text-align: center;
    }
  }
}
</style>
